import { createSelector } from 'reselect';

const selectProductNature = (state: any) => state.ProductNature;


export const selectProductNatureCurrentItem = createSelector([selectProductNature], (ProductNature) => ProductNature.current);

export const selectProductNatureListItems = createSelector([selectProductNature], (ProductNature) => ProductNature.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectProductNatureListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectProductNatureQueryItems = createSelector([selectProductNature], (ProductNature) => ProductNature.query);

export const selectProductNatureCreatedItem = createSelector([selectProductNature], (ProductNature) => ProductNature.create);

export const selectProductNatureUpdatedItem = createSelector([selectProductNature], (ProductNature) => ProductNature.update);

export const selectProductNatureReadItem = createSelector([selectProductNature], (ProductNature) => ProductNature.read);

export const selectProductNatureDeletedItem = createSelector([selectProductNature], (ProductNature) => ProductNature.delete);

export const selectProductNatureSearchedItems = createSelector([selectProductNature], (ProductNature) => ProductNature.search);

export const selectProductNatureItemsCount = createSelector([selectProductNature], (ProductNature) => ProductNature.count);

export const selectProductNatureItemsFilter = createSelector([selectProductNature], (ProductNature) => ProductNature.filter);